import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class ReportService {
  async getProgramSummaryReport(user, payload) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/programs/report`, MICROSERVICES.PROGRAMMANAGER), { params: { report_type: payload.report_type, input_account_id: payload.account } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getEventSummaryReport(user, payload) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/vppevent/report`, MICROSERVICES.VPPMANAGER), { params: { report_type: payload.report_type, input_account_id: payload.account, input_program_id: payload.program, start_date: payload.start_date, end_date: payload.end_date } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getEventTelemetryReport(user, payload) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/vppevent/telemetry/report`, MICROSERVICES.VPPMANAGER), { params: { report_type: payload.report_type, input_account_id: payload.account, input_program_id: payload.program, input_event_id: payload.eventId } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getUserSummaryReport(user, payload) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/user/report`, MICROSERVICES.SESSIONMANAGER), { params: { report_type: payload.report_type, input_account_id: payload.account } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getProductionForecastReport(user, payload, account, program) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${user.account_id}/${payload.account}/program/${payload.program}/report/production/${user.id}`, MICROSERVICES.REPORTMANAGER), {
        "accountName": account.company_name || account.account_company_name,
        "programName": program.name,
        "userName": user.user_name,
      }, { params: { number_of_days: payload.duration, report_type: payload.report_type } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getLoadReport(user, payload, forecast_report_type, account, program) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${user.account_id}/${payload.account}/program/${payload.program}/report/soc_prediction/${user.id}`, MICROSERVICES.REPORTMANAGER), {
        "accountName": account.company_name || account.account_company_name,
        "programName": program.name,
        "userName": user.user_name,
      }, { params: { forecast_report_type: forecast_report_type, number_of_days: payload.duration, report_type: payload.report_type } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getSystemDetailsReport(user, payload) {
    const params = { input_account_id: payload.account, report_type: payload.report_type }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/site/${payload.site}/report`, MICROSERVICES.SITEMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getEventParticipationHistoryReport(user, payload) {
    const params = { input_account_id: payload.account, report_type: payload.report_type, program_id: payload.program }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/vppevent/report/eventparticipationhistory/${payload.site}`, MICROSERVICES.VPPMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const reportService = new ReportService()
